import React from 'react';
import TaxonomyTermPillarTeaser from './Teaser';
import Full from './Full';

const TaxonomyTermPillar = ({ entity, viewMode }) => {
  switch (viewMode) {
    case 'teaser':
      return (<TaxonomyTermPillarTeaser entity={entity} />);
    case 'full':
    default:
      return (<Full entity={entity} />);
  }
};

export default TaxonomyTermPillar;
